// ispencil/ispencil.js

import { Plugin } from 'ckeditor5';
import IsPencilEditing from './ispencilediting';
import IsCanvas from './ispen/iscanvas';
import IsPencilToolbar from './ispenciltoolbar';
import IsPencilUI from './ispencilui';

import './style.css';

export default class IsPencil extends Plugin {

    static get pluginName() {
		return 'IsPencil';
	}

    static get requires() {
        return [ IsPencilEditing, IsCanvas, IsPencilToolbar, IsPencilUI ];
    }

    init() {
        // console.log( 'IsPencil#init' );
        /*
        In a first version the special CSS required by isPencil was injected here.
        The same CSS is needed also when no editor is instantiated. 
        Anyhow, it is not necessary to inject CSS, it suffices to import the needed styles from a suitable file as it is done here with styles.css
        */
    }
}